(() => {
  const root = document.querySelector("[data-lead-form]");
  if (!root) return;

  const form = root.querySelector("[data-lead-form-form]");
  const dialog = root.querySelector(".lead-form__dialog");
  const status = root.querySelector("[data-lead-form-status]");
  const nextButton = root.querySelector("[data-lead-form-next]");
  const backButton = root.querySelector("[data-lead-form-back]");
  const submitButton = form.querySelector('button[type="submit"]');
  const triggerIdField = root.querySelector("[data-lead-form-trigger-id]");
  const triggerTextField = root.querySelector("[data-lead-form-trigger-text]");
  const storageKey = "reeis_lead_attribution";
  const sessionKey = "reeis_lead_session_attribution";
  const landingKey = "reeis_first_landing_page";
  const attributionKeys = [
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "ttclid",
    "msclkid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
  ];

  const config = {
    webhookUrl: root.dataset.ghlWebhook || "",
    source: "REEIS Website",
    formName: "Book Now Modal",
    step1Event: "lead_form_step1",
    submitEvent: "lead_form_submitted",
  };

  let lastFocusedElement = null;
  let stepOnePayload = null;

  function safeGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (_error) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (_error) {
      return false;
    }
    return true;
  }

  function readJson(storage, key) {
    const value = safeGet(storage, key);
    if (!value) return {};
    try {
      return JSON.parse(value) || {};
    } catch (_error) {
      return {};
    }
  }

  function getCookie(name) {
    return (
      document.cookie
        .split(";")
        .map((cookie) => cookie.trim())
        .find((cookie) => cookie.startsWith(`${name}=`))
        ?.split("=")
        .slice(1)
        .join("=") || ""
    );
  }

  function getCurrentAttribution() {
    const params = new URLSearchParams(window.location.search);
    return attributionKeys.reduce((data, key) => {
      const value = params.get(key);
      if (value) data[key] = value;
      return data;
    }, {});
  }

  function persistAttribution() {
    const current = getCurrentAttribution();
    const landingPage = safeGet(localStorage, landingKey) || window.location.href;

    safeSet(localStorage, landingKey, landingPage);

    if (Object.keys(current).length > 0) {
      const previous = readJson(localStorage, storageKey);
      const merged = { ...previous, ...current };
      safeSet(localStorage, storageKey, JSON.stringify(merged));
      safeSet(sessionStorage, sessionKey, JSON.stringify(merged));
    }
  }

  function collectAttribution() {
    const current = getCurrentAttribution();
    const local = readJson(localStorage, storageKey);
    const session = readJson(sessionStorage, sessionKey);
    const cookies = {
      _fbc: decodeURIComponent(getCookie("_fbc")),
      _fbp: decodeURIComponent(getCookie("_fbp")),
    };

    return {
      ...session,
      ...local,
      ...current,
      _fbc: current._fbc || local._fbc || session._fbc || cookies._fbc || "",
      _fbp: current._fbp || local._fbp || session._fbp || cookies._fbp || "",
      landing_page: safeGet(localStorage, landingKey) || window.location.href,
      current_page: window.location.href,
      referrer: document.referrer || "",
      timestamp: new Date().toISOString(),
    };
  }

  function pushEvent(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload });
  }

  function setStep(step) {
    root.querySelectorAll("[data-lead-form-step]").forEach((stepElement) => {
      stepElement.hidden = stepElement.dataset.leadFormStep !== String(step);
    });
    status.textContent = "";
    status.classList.remove("is-error");
  }

  function setStatus(message, isError) {
    status.textContent = message;
    status.classList.toggle("is-error", Boolean(isError));
  }

  function setBusy(isBusy) {
    nextButton.disabled = isBusy;
    submitButton.disabled = isBusy;
  }

  function normalizePhone(value) {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    if (digits.length < 4) return digits;
    if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  function getStepFields(step) {
    return Array.from(
      root.querySelectorAll(
        `[data-lead-form-step="${step}"] input, [data-lead-form-step="${step}"] select, [data-lead-form-step="${step}"] textarea`,
      ),
    );
  }

  function validateStep(step) {
    const fields = getStepFields(step);
    const invalid = fields.find((field) => !field.checkValidity());
    if (invalid) {
      invalid.reportValidity();
      return false;
    }
    return true;
  }

  function formDataPayload() {
    const data = new FormData(form);
    const payload = Object.fromEntries(data.entries());
    payload.emergency = form.elements.emergency.checked;
    return payload;
  }

  async function postLead(step, payload) {
    const body = {
      source: config.source,
      form_name: config.formName,
      step,
      ...payload,
      ...collectAttribution(),
    };

    if (!config.webhookUrl) {
      console.info("[REEIS Lead Form] GHL webhook placeholder payload", body);
      return { skipped: true, body };
    }

    const response = await fetch(config.webhookUrl, {
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
      method: "POST",
    });

    if (!response.ok) {
      throw new Error(`GHL webhook returned ${response.status}`);
    }

    return { skipped: false, body };
  }

  function resetForm() {
    form.reset();
    form.querySelectorAll("input, select, textarea, button").forEach((field) => {
      field.disabled = false;
    });
    stepOnePayload = null;
    setStep(1);
    setStatus("", false);
  }

  function openModal(trigger) {
    lastFocusedElement = document.activeElement;
    resetForm();
    triggerIdField.value = trigger.id || "";
    triggerTextField.value = trigger.textContent.trim().slice(0, 80);
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("lead-form-open");
    dialog.focus();
    pushEvent("lead_form_opened", {
      trigger_id: triggerIdField.value,
      trigger_text: triggerTextField.value,
    });
  }

  function closeModal() {
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("lead-form-open");
    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      lastFocusedElement.focus();
    }
  }

  function isIgnoredLink(element) {
    const href = (element.getAttribute("href") || "").toLowerCase();
    const hasBookingClass = element.classList.contains("book-now") || element.classList.contains("appointment-button");

    return (
      href.startsWith("tel:") ||
      href.startsWith("sms:") ||
      href.startsWith("mailto:") ||
      element.classList.contains("print") ||
      element.classList.contains("link-sms-coupon") ||
      element.closest("[data-form-pop-up]") ||
      element.closest("form-popup") ||
      element.closest("nav") ||
      element.closest(".site-nav") ||
      element.closest("footer") ||
      element.closest(".footer") ||
      (element.classList.contains("no-action-button") && href && !hasBookingClass)
    );
  }

  function isServiceTitanTrigger(element) {
    return (
      (element.id === "navbar-scheduler-button" ||
        element.dataset.serviceTitanScheduler === "true" ||
        element.closest("header") ||
        element.closest(".header")) &&
      element.getAttribute("data-make-appointment") === "true"
    );
  }

  function isLeadTrigger(element) {
    if (isIgnoredLink(element) || isServiceTitanTrigger(element)) return false;
    const text = element.textContent.trim().toLowerCase();
    return (
      element.matches("[data-ghl-lead-form]") ||
      element.classList.contains("book-now") ||
      element.classList.contains("appointment-button") ||
      element.classList.contains("wrkbelt-scheduler-button") ||
      element.getAttribute("data-make-appointment") === "true" ||
      text === "book now"
    );
  }

  function openServiceTitan(trigger) {
    pushEvent("service_titan_scheduler_opened", {
      trigger_id: trigger.id || "",
      trigger_text: trigger.textContent.trim().slice(0, 80),
    });

    if (!trigger.classList.contains("se-booking-show") && window.ScheduleEngine?.showAppointments) {
      window.ScheduleEngine.showAppointments();
    }
  }

  function bindRouter() {
    document.addEventListener(
      "click",
      (event) => {
        const trigger = event.target.closest("a, button");
        if (!trigger) return;

        if (isServiceTitanTrigger(trigger)) {
          openServiceTitan(trigger);
          return;
        }

        if (!isLeadTrigger(trigger)) return;
        event.preventDefault();
        event.stopPropagation();
        openModal(trigger);
      },
      true,
    );
  }

  persistAttribution();
  bindRouter();

  root.addEventListener("click", (event) => {
    if (event.target.closest("[data-lead-form-close]")) {
      closeModal();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && root.classList.contains("is-open")) {
      closeModal();
    }
  });

  form.elements.phone.addEventListener("input", (event) => {
    event.target.value = normalizePhone(event.target.value);
  });

  backButton.addEventListener("click", () => {
    setStep(1);
  });

  nextButton.addEventListener("click", async () => {
    if (!validateStep(1)) return;

    setBusy(true);
    setStatus("Saving your contact info...", false);

    try {
      stepOnePayload = formDataPayload();
      const result = await postLead(1, stepOnePayload);
      pushEvent(config.step1Event, {
        trigger_id: triggerIdField.value,
        webhook_skipped: result.skipped,
      });
      setStep(2);
    } catch (error) {
      setStatus("We could not save your contact info. Please try again or call us.", true);
      console.error("[REEIS Lead Form] Step 1 failed", error);
    } finally {
      setBusy(false);
    }
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!validateStep(2)) return;

    setBusy(true);
    setStatus("Sending your request...", false);

    try {
      const result = await postLead(2, {
        ...stepOnePayload,
        ...formDataPayload(),
      });
      pushEvent(config.submitEvent, {
        trigger_id: triggerIdField.value,
        webhook_skipped: result.skipped,
      });
      setStatus("Thanks. Your request has been received and REEIS will follow up shortly.", false);
      form.querySelectorAll("input, select, textarea, button").forEach((field) => {
        field.disabled = true;
      });
    } catch (error) {
      setStatus("We could not send your request. Please try again or call us.", true);
      console.error("[REEIS Lead Form] Step 2 failed", error);
    } finally {
      setBusy(false);
    }
  });
})();
